export default __webpack_public_path__ + "a169fc3c6902a5253186ae279710413b.svg";